import Vue from 'vue';
import App from './App.vue';
import VueGtm from 'vue-gtm';
import VueSegmentAnalytics from 'vue-segment-analytics';
import VueClipboard from 'vue-clipboard2';
import VScrollLock from 'v-scroll-lock';
import VueMq from 'vue-mq';
import router from './router';
import store from './store';
import Element from 'element-ui';
import './registerServiceWorker';
import './element-variables.scss';
import moment from 'moment';
import locale from 'element-ui/lib/locale/lang/ko';
import 'swiper/css/swiper.css';

Vue.use(VScrollLock);
Vue.use(Element, { locale });
if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtm, {
    id: 'GTM-MLKL8CV',
    enabled: true,
    debug: false,
    vueRouter: router,
  });
  Vue.use(VueSegmentAnalytics, {
    id: '2zJeorPkNsElvqiPBJ4BvSGUCX8lc8Cl',
    router,
  });
}
Vue.use(VueClipboard);
Vue.use(VueMq, {
  breakpoints: {
    sm: 769,
    md: 1281,
    lg: Infinity,
  },
});
Vue.filter('dateParser', (v: any) => moment(v).format('YYYY-MM-DD'));
Vue.filter('commaPrice', (v: any) => {
  if (v !== null) v = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return v;
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
